export default __webpack_public_path__ + "static/pig02-976bbf7c98e2f80d9438baaa77deca80.png";